import { TValidOtherSchoolTypes } from './../../shared/typings/interfaces/student.interface';
const ALL_SCHOOL_TYPES = ['ES', 'MS', 'HS'];

export type TValidStudentTypes = 'ES' | 'MS' | 'HS';

export interface IStudentPanel {
  id: string;
  human: string;
  studentTypes: TValidStudentTypes[];
  otherSchoolTypes?: TValidOtherSchoolTypes[];
}
export interface IStudentPanels {
  [propName: string]: IStudentPanel;
}

/**
 * NOTE: Each panel has a config file in its directory that contains the panel title and paths.
 * The title there MUST match the human name here. TODO: Tighten up. - JYR.
 */
export const StudentPanelsConfig = {
  BASIC_INFO: {
    id: 'student-basic-info-panel',
    human: 'Basic Info',
    studentTypes: ALL_SCHOOL_TYPES,
    otherSchoolTypes: ['summer'],
  },
  ATTENDANCE: {
    id: 'student-attendance-panel',
    human: 'Attendance',
    studentTypes: ALL_SCHOOL_TYPES,
    hideForSummerSchoolStudent: false,
    otherSchoolTypes: ['summer'],
  },
  ASSIGNED_SUPPORTS: {
    id: 'student-supports-panel',
    human: 'Supports',
    studentTypes: ALL_SCHOOL_TYPES,
    otherSchoolTypes: [],
  },
  ACADEMIC: {
    id: 'student-academic-panel',
    human: 'Academic',
    studentTypes: ['ES', 'MS'],
    otherSchoolTypes: ['summer'],
  },
  STUDENT_SNAPSHOT: {
    id: 'student-snapshot-panel',
    human: 'Student Snapshot',
    studentTypes: ['HS'],
    otherSchoolTypes: ['summer'],
  },
  GRAD_PLANNING: {
    id: 'student-grad-panel-v3',
    human: 'Graduation',
    studentTypes: ['HS'],
    otherSchoolTypes: [],
  },
  REMOTE_LEARNING: {
    id: 'remote-learning-panel',
    human: 'Remote Learning',
    studentTypes: ALL_SCHOOL_TYPES,
    otherSchoolTypes: [],
  },
  CURRENT_PROGRAM: {
    id: 'student-current-program-panel',
    human: 'Current Program',
    studentTypes: ['HS'],
    otherSchoolTypes: ['summer'],
  },
  CREDITS: {
    id: 'student-credits-panel',
    human: 'Credits',
    studentTypes: ['HS'],
    otherSchoolTypes: ['summer'],
  },
  CREDIT_GAPS: {
    id: 'student-credit-gaps-panel',
    human: 'Credit Gaps',
    studentTypes: ['HS'],
    otherSchoolTypes: ['summer'],
  },
  REGENTS: {
    id: 'student-regents-panel',
    human: 'Regents',
    studentTypes: ['HS'],
    otherSchoolTypes: ['summer'],
  },
  NOTES: {
    id: 'student-notes-panel',
    human: 'Notes',
    studentTypes: ALL_SCHOOL_TYPES,
    otherSchoolTypes: [],
  },
  FULL_EXAM_HISTORY: {
    id: 'student-full-exam-history-panel',
    human: 'Full Exam History',
    studentTypes: ['HS'],
    otherSchoolTypes: [],
  },
  FULL_TRANSCRIPT_HISTORY: {
    id: 'student-full-transcript-history-panel',
    human: 'Full Transcript History',
    studentTypes: ['HS'],
    otherSchoolTypes: ['summer'],
  },
  POINT_PEOPLE: {
    id: 'student-point-people-panel',
    human: 'Point People',
    studentTypes: ALL_SCHOOL_TYPES,
    otherSchoolTypes: [],
  },
  POSTSECONDARY: {
    id: 'student-postsec-panel',
    human: 'Postsecondary',
    studentTypes: ['HS'],
    otherSchoolTypes: [],
  },
};

export default StudentPanelsConfig;
